<template>
  <div>
    <div v-if="loan">
      <section-title
        content="Información de Facilitación de Equipo"
        has-line
        class="mt-4"
      />
      <div class="m-2 pt-1">
        <div class="row mb-2">
          <div class="col-12 col-lg-2 mb-4">
            <p class="font-14 text-muted mb-1">
              Tipo de Facilidad:
            </p>
            <p class="font-16">
              {{ loan.type | empty }}
            </p>
          </div>
          <div class="col-12 col-lg-3 mb-4">
            <p class="font-14 text-muted mb-1">
              Nombre del Estudiante y Número de SIE:
            </p>
            <p class="font-16">
              {{ loan.student | empty }}
            </p>
          </div>
          <div class="col-12 col-lg-2 mb-4">
            <p class="font-14 text-muted mb-1">
              Razón:
            </p>
            <p class="font-16">
              {{ loan.reason | empty }}
            </p>
          </div>
          <div class="col-12 col-lg-2 mb-4">
            <p class="font-14 text-muted mb-1">
              CAAT:
            </p>
            <p class="font-16">
              {{ loan.caat | empty }}
            </p>
          </div>
          <div class="col-12 col-lg-2 mb-4">
            <p class="font-14 text-muted mb-1">
              Fecha de Devolución Estimada:
            </p>
            <p class="font-16">
              {{ loan.returnDate | date }}
            </p>
          </div>
          <div class="col-12 col-lg-2 mb-4">
            <p class="font-14 text-muted mb-1">
              Fecha de Extensión:
            </p>
            <p class="font-16">
              {{ loan.extensionDate | date }}
            </p>
          </div>
          <div class="col-12 col-lg-2 mb-4">
            <p class="font-14 text-muted mb-1">
              Fecha de Facilitación:
            </p>
            <p class="font-16">
              {{ loan.createdDate | date }}
            </p>
          </div>
          <div class="col-12 col-lg-3 mb-4">
            <p class="font-14 text-muted mb-1">
              Número de Contacto:
            </p>
            <p class="font-16">
              {{ loan.phone | phone }}
            </p>
          </div>
          <div class="col-12 col-lg-2 mb-4">
            <p class="font-14 text-muted mb-1">
              Número de Expediente:
            </p>
            <p class="font-16">
              {{ loan.expedient | empty }}
            </p>
          </div>
          <div class="col-12 col-lg-2 mb-4">
            <p class="font-14 text-muted mb-1">
              Realizado por:
            </p>
            <p class="font-16">
              {{ loan.createdBy | empty }}
            </p>
          </div>
          <div class="col-12 col-lg-2 mb-4">
            <p class="font-14 text-muted mb-1">
              Comentario:
            </p>
            <p class="font-16">
              {{ loan.comment | empty }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loanReturn">
      <section-title
        content="Información de Devolución de Equipo"
        has-line
        class="mt-4"
      />
      <div class="m-2 pt-1">
        <div class="row mb-2">
          <div class="col-12 col-lg-3 mb-4">
            <p class="font-14 text-muted mb-1">
              Nombre del Estudiante y Número de SIE:
            </p>
            <p class="font-16">
              {{ loan.student | empty }}
            </p>
          </div>
          <div class="col-12 col-lg-3 mb-4">
            <p class="font-14 text-muted mb-1">
              CAAT:
            </p>
            <p class="font-16">
              {{ loan.caat | empty }}
            </p>
          </div>
          <div class="col-12 col-lg-3 mb-4">
            <p class="font-14 text-muted mb-1">
              Fecha de Entrega:
            </p>
            <p class="font-16">
              {{ loan.createdDate | date }}
            </p>
          </div>
          <div class="col-12 col-lg-3 mb-4">
            <p class="font-14 text-muted mb-1">
              Fecha de Devolución:
            </p>
            <p class="font-16">
              {{ loanReturn.returnDate | date }}
            </p>
          </div>
          <div class="col-12 col-lg-3 mb-4">
            <p class="font-14 text-muted mb-1">
              Realizado por:
            </p>
            <p class="font-16">
              {{ loan.createdBy | empty }}
            </p>
          </div>
          <div class="col-12 col-lg-3 mb-4">
            <p class="font-14 text-muted mb-1">
              Comentario:
            </p>
            <p class="font-16">
              {{ loan.comment | empty }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import typeFacility from '@/utils/constants/typeFacility';

export default {
  name: 'EquipmentInformation',
  components: {
    SectionTitle,
  },

  props: {
    loan: {
      type: Object,
      default: () => ({}),
    },
    loanReturn: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isFacilityTypeDonated() {
      return typeFacility.DONACION == this.loan?.typeId;
    },
  },
};
</script>

<style lang="scss" scoped></style>
